import { AutomedClinicAvailabilityTimeModel, AutomedDoctorAvailabilityTimeModel } from "src/services/availability";

export function toAutomedDoctorAvailabilityTimeModel(timeslot: AutomedClinicAvailabilityTimeModel | AutomedDoctorAvailabilityTimeModel): AutomedDoctorAvailabilityTimeModel {
    if(!timeslot) {
        return timeslot;
    }
    if("t" in timeslot) {
        const t2 = timeslot as Partial<AutomedClinicAvailabilityTimeModel & AutomedDoctorAvailabilityTimeModel>;
        t2.duration = t2.d;
        t2.time = t2.t
        delete(t2.d);
        delete(t2.t);

        return t2 as AutomedDoctorAvailabilityTimeModel;
    }
    return timeslot
}
export function toAutomedClinicAvailabilityTimeModel(timeslot: AutomedClinicAvailabilityTimeModel | AutomedDoctorAvailabilityTimeModel): AutomedClinicAvailabilityTimeModel {
    if(!timeslot) {
        return timeslot;
    }
    if("time" in timeslot) {
        const t2 = timeslot as Partial<AutomedClinicAvailabilityTimeModel & AutomedDoctorAvailabilityTimeModel>;
        t2.d = t2.duration;
        t2.t = t2.time
        delete(t2.duration);
        delete(t2.time);

        return t2 as AutomedClinicAvailabilityTimeModel;
    }
    return timeslot
}